/* import __COLOCATED_TEMPLATE__ from './categories-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();